import images from "./images";

const testimonials = [
  {
    id: 1,
    image: images.testimonial1,
    name: "Michael Johnson",
    title: "Home Renovation Enthusiast",
    content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero voluptate omnis hic? Omnis repudiandae aliquid iure beatae distinctio temporibus quia expedita earum aliquam consequuntur. Tempora totam eum quos veniam illo.",
  },
  {
    id: 2,
    image: images.testimonial2,
    name: "Emma Thompson",
    title: "Interior Design Consultant",
    content: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias et sint suscipit, non quo aut, cumque repudiandae molestiae fugiat animi distinctio blanditiis tempore? Quam accusantium sed veritatis officiis obcaecati cupiditate.",
  },
  {
    id: 3,
    image: images.testimonial3,
    name: "David Williams",
    title: "Property Developer",
    content: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias et sint suscipit, non quo aut, cumque repudiandae molestiae fugiat animi distinctio blanditiis tempore? Quam accusantium sed veritatis officiis obcaecati cupiditate.",
  },
  {
    id: 4,
    image: images.testimonial4,
    name: "Olivia Brown",
    title: "Building Contractor",
    content:  "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Molestias et sint suscipit, non quo aut, cumque repudiandae molestiae fugiat animi distinctio blanditiis tempore? Quam accusantium sed veritatis officiis obcaecati cupiditate.",
  },
];

export default testimonials;